export function getResponseConfig(listSize) {
  if (listSize === 2) {
    return [
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToScroll: 2,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 5000,
        settings: {
          slidesToScroll: 3,
          slidesToShow: 3,
        },
      }
    ]
  } else {
    return [
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 2,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 5000,
        settings: {
          slidesToScroll: 3,
          slidesToShow: 3,
        },
      },
    ]
  }
}
